import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const UofTStGeorge = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="University of Toronto – St. George Campus"
      universityShortName="U of T St. George"
      slug="university-of-toronto-st-george"
      seoTitle="University of Toronto St. George Study Rooms | Campus Study Guide"
      seoDescription="Complete guide to study rooms at University of Toronto St. George campus. Find Robarts Library, Gerstein, Hart House study spaces. Plus free 24/7 online alternative."
      seoKeywords="university of toronto study rooms, robarts library study rooms, u of t study spaces, robarts common, gerstein library, hart house reading room, toronto university library"
      canonicalUrl="/study-room/university-of-toronto-st-george/"
      heroDescription="A comprehensive guide to study rooms and spaces at U of T's downtown campus, including Robarts Library, Gerstein, and Hart House."
      libraryWebsiteUrl="https://onesearch.library.utoronto.ca/"
      libraryWebsiteName="U of T Library"
      studySpaces={[
        {
          name: "Robarts Library & Robarts Common (130 St. George St.)",
          features: "The five-storey Robarts Common (opened in 2022) adds space for ~1,200 students and includes eight bookable group-study rooms. The extension features sound-proof rooms, accessible seating and quiet zones.",
          feedback: "Students appreciate the extra seats and sound-proof rooms but note that study rooms fill quickly and were unavailable during pandemic restrictions."
        },
        {
          name: "Gerstein Science Information Centre",
          features: "Main science library with hundreds of seats; historically offered group study rooms. During early reopening in 2020 it had 309 seats and required pre-booking.",
          feedback: "Study rooms were not available during pandemic and seats had strict booking times."
        },
        {
          name: "Bora Laskin Law Library",
          features: "Quiet reading areas plus bookable group study rooms accessible only to law students; spaces require online booking and there is a 50% capacity limit.",
          feedback: "Access limited to law students; other students cannot use these rooms."
        },
        {
          name: "Hart House Reading Rooms",
          features: "The Hart House Reading Room, Map Room and library offer bookable study areas with stained glass and gothic décor.",
          feedback: "Spaces have limited hours and may be closed for events; not everyone likes the historic furniture."
        },
        {
          name: "Off-campus Cafés (Ten DEAN, Goldstruck Coffee, Lait Night)",
          features: "Local cafés around campus provide late-night study spaces. Goldstruck and Lait Night have extended hours and strong coffee.",
          feedback: "Can be noisy; require purchase of food or drink."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            <strong>Robarts Library</strong> is the heart of U of T studying and its new Robarts Common finally tackles crowding by offering hundreds of extra seats and sound-proof rooms. When you need to power through readings, reserve one of the eight group rooms or head to the upper floors of Robarts for quiet.
          </p>
          <p className="mb-4">
            Science students often favour <strong>Gerstein</strong>, but availability can be scarce during exam periods, so look for off-peak hours or study in the bright <strong>Hart House rooms</strong> if you want a Hogwarts-like atmosphere.
          </p>
          <p>
            For casual group work, neighbourhood cafés like <strong>Ten DEAN</strong> or <strong>Goldstruck</strong> provide a more relaxed setting, albeit with more noise. Overall, plan ahead—peak-time bookings fill quickly, but UTSG's variety of historic and modern spaces means there's a study niche for every mood.
          </p>
        </>
      }
      summaryTips={[
        "Book early: Robarts group study rooms fill quickly, especially during midterms and finals. Reserve online as soon as booking opens.",
        "Explore the upper floors: Floors 9-13 of Robarts offer quieter study environments away from the busier lower levels.",
        "Try Hart House for atmosphere: The gothic reading rooms provide a unique study experience if you can handle the historic seating.",
        "Consider off-peak hours: Early mornings and late evenings typically have more availability in popular spaces.",
        "Use CSW as backup: When all physical rooms are booked, CSW offers unlimited virtual study rooms with 24/7 access."
      ]}
    />
  );
};

export default UofTStGeorge;
